import Layout from '../components/Layout';
import FinalizarCompra from '../components/finalizarCompra';


const Pedido = () => {

	return (
		<Layout
			pagina={"Mi pedido"}
		>
			<div className='w-full pt-20 pb-20'>
                <FinalizarCompra />
			</div>
		</Layout>
	)
}

export default Pedido